export const GET_LEADS_SUCCESS = 'GET_LEADS_SUCCESS';
export const GET_LEADS_FAIL = 'GET_LEADS_FAIL';

export const GET_LEAD_BY_ID_SUCCESS = 'GET_LEAD_BY_ID_SUCCESS';
export const GET_LEAD_BY_ID_FAIL = 'GET_LEAD_BY_ID_FAIL';

export const DELETE_LEAD_BY_ID_SUCCESS = 'DELETE_LEAD_BY_ID_SUCCESS';
export const DELETE_LEAD_BY_ID_FAIL = 'DELETE_LEAD_BY_ID_FAIL';

export const GET_EXTRA_FORMS_SUCCESS = 'GET_EXTRA_FORMS_SUCCESS';
export const GET_EXTRA_FORMS_FAIL = 'GET_EXTRA_FORMS_FAIL';

export const GET_SALES_AGENTS_SUCCESS = 'GET_SALES_AGENTS_SUCCESS';
export const GET_SALES_AGENTS_FAIL = 'GET_SALES_AGENTS_FAIL';

export const OPEN_MODAL_SUCCESS = 'OPEN_MODAL_SUCCESS';
export const OPEN_MODAL_FAIL = 'OPEN_MODAL_FAIL';

export const CLOSE_MODAL_SUCCESS = 'CLOSE_MODAL_SUCCESS';
export const CLOSE_MODAL_FAIL = 'CLOSE_MODAL_FAIL';

export const GET_LEADS_APPOINTMENT_SUCCESS = 'GET_LEADS_APPOINTMENT_SUCCESS';
export const GET_LEADS_APPOINTMENT_FAIL = 'GET_LEADS_APPOINTMENT_FAIL';

export const GET_PENDING_DOC_SUCCESS = 'GET_PENDING_DOC_SUCCESS';
export const GET_PENDING_DOC_FAIL = 'GET_PENDING_DOC_FAIL';

export const SET_DEAL_STATUS_FILTER_BY_SUCCESS =
	'SET_DEAL_STATUS_FILTER_BY_SUCCESS';
export const SET_DEAL_STATUS_FILTER_BY_FAIL = 'SET_DEAL_STATUS_FILTER_BY_FAIL';

export const CLEAR_DEAL_STATUS_FILTER_SUCCESS =
	'CLEAR_DEAL_STATUS_FILTER_SUCCESS';
export const CLEAR_DEAL_STATUS_FILTER_FAIL = 'CLEAR_DEAL_STATUS_FILTER_FAIL';

export const SET_DEALS_SECTION = 'SET_DEALS_SECTION';

export const CLEAR_LEAD_BY_ID_SUCCESS = 'CLEAR_LEAD_BY_ID_SUCCESS';
